import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";

import NavBar from "../components/NavBar";
import FrTextInput from '../components/FrTextInput';
import UserOptions from "../components/UserOptions";
import FrLoading from "../components/FrLoading";

import api from '../services/api';
import { conferePermissao, paramsToObject } from "../utils/functions";

import './styles/DefaultReg.css';
import FooterDelphus from "../components/FooterDelphus";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const swal = withReactContent(Swal);

const RegTipo_Chamado = () => {

    const [data, setData] = useState({});
    const [updateType, setUpdateType] = useState(false);
    const [enableEdit, setEnableEdit] = useState('N');

    useEffect(() => {
        const fetchData = async () => {
            let tela = 'Tipos Chamados'
            let consulta = await api.getAcessos(tela, 'Consulta')
            if (consulta !== 'S') {
                swal.fire('Usuário sem acesso', 'Usuário sem acesso a essa tela!', 'warning')
                    .then((result) => {
                        if (result.value) {
                            window.history.back()
                        }
                    })
            } else {

                swal.fire({
                    html: <FrLoading text="Carregando..." />,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });

                const urlParams = new URLSearchParams(window.location.search);
                let query = paramsToObject(urlParams);

                if (query.codigo > 0) {
                    setUpdateType(true);
                    api.get('/tipo_chamado?pk_tch=' + query.codigo).then(r => {
                        if (r.data[0]) {
                            setData(r.data[0]);
                            swal.close();
                        } else {
                            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning').then((result) => {
                                window.history.back();
                            });
                        }
                    });
                } else swal.close();
            }
        }
        fetchData();
    }, []);

    const consistData = (data) => {
        let required = [
        ];

        let errors = [];

        required.forEach((curr, index) => {
            let fieldName = curr;
            if (!data[curr]) return errors.push(fieldName);
        });

        return errors;
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        swal.fire({
            title: 'ATENÇÃO',
            text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                const auxValues = { ...data };
                let errors = consistData(auxValues);
                console.log(errors.length);
                if (errors.length === 0) {
                    if (updateType) {
                        api.post('/tipo_chamado/edit', auxValues).then(r => {
                            if (r.status === 200) {
                                swal.fire({
                                    title: 'Registro Alteraddo',
                                    text: "O registro foi alterado com sucesso!",
                                    icon: 'success',
                                }).then((result) => {
                                    if (result.value) {
                                        window.history.back();
                                    }
                                });
                            } else {
                                swal.fire({
                                    title: 'Erro!',
                                    text: "O registro não foi alterado!",
                                    icon: 'warning',
                                })
                            }
                        });
                    } else {
                        api.post('/tipo_chamado/add', auxValues).then(r => {
                            if (r.status === 200) {
                                swal.fire({
                                    title: 'Registro Adicionado',
                                    text: "O registro foi adicionado com sucesso!",
                                    icon: 'success',
                                }).then((result) => {
                                    if (result.value) {
                                        window.history.back()
                                    }
                                });
                            } else {
                                swal.fire({
                                    title: 'Erro!',
                                    text: "O registro não foi adicionado!",
                                    icon: 'warning',
                                });
                            }
                        });
                    }
                } else {
                    swal.fire({
                        title: 'Erro!',
                        text: "Verifique o(s) campo(s) " + errors.join(','),
                        icon: "warning"
                    });
                }
            }
        });
    }

    const handleCancel = (e) => {
        e.preventDefault();
        swal.fire({
            title: 'ATENÇÃO',
            text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                window.history.back();
            }
        });
    }

    const handleChange = (e) => {
        const auxValues = { ...data };
        switch (e.target.name) {
            case 'ativo':
                auxValues[e.target.name] = (auxValues[e.target.name] === 'S' ? 'N' : 'S')
                break
            default: auxValues[e.target.name] = e.target.value;
        }

        setData(auxValues);
    }

    return (
        <div className="defaultReg">
            <NavBar />
            <div className="defaultRegContent">
                <div className="defaultHeader">
                    <h3>{updateType ? 'Edição' : 'Inclusão'} de Situacao</h3>
                    <UserOptions />
                </div>
                <br />
                <form id="regForm" onSubmit={handleSubmit}>

                    <FrTextInput
                        value={data.descricao || ''}
                        style={{ width: 280 }}
                        name="descricao"
                        id="descricao"
                        color="#9c9595"
                        label="Descrição"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                    />


                    <FormControlLabel
                        control={
                            <Checkbox
                                name='ativo'
                                id='ativo'
                                size='small'
                                color="primary"
                                value={data.ativo || ''}
                                checked={data.ativo === 'S'}
                                onChange={handleChange}
                            />
                        }
                        label={'Ativo'}
                    />
                </form>
                <div className="regButtonsDiv">
                    <button onClick={handleSubmit}>Salvar</button>
                    <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
                </div>
                <FooterDelphus />
            </div>
        </div>
    );
}

export default RegTipo_Chamado;